export default __webpack_public_path__ + "static/media/bitcoin.31361c80.gif";